import { gql } from "@apollo/client";

const GET_TR_COUNT = gql`
  query TraineeshipCount(
    $sendingHeiID: String!
    $status: String
    $studentFirstName: String
    $studentLastName: String
    $sendingErasmusCode: String
    $sendingCountry: [String]
    $createdBy: String
    $iscedId: String
    $traineeshipId: String
    $receivingOrganization: String
    $receivingCountry: String
    $sendingContactFirstName: String
    $sendingContactLastName: String
  ) {
    traineeshipCount(
      sendingHeiID: $sendingHeiID
      status: $status
      studentFirstName: $studentFirstName
      studentLastName: $studentLastName
      sendingErasmusCode: $sendingErasmusCode
      sendingCountry: $sendingCountry
      createdBy: $createdBy
      iscedId: $iscedId
      traineeshipId: $traineeshipId
      receivingOrganization: $receivingOrganization
      receivingCountry: $receivingCountry
      sendingContactFirstName: $sendingContactFirstName
      sendingContactLastName: $sendingContactLastName
    )
  }
`;

export default GET_TR_COUNT;